import React from "react";
import { GenericDropdownItem } from "@sonder/ui/source/styled/fragments/GenericDropdownItem";
import { UserCardInDropdownItem } from "@sonder/ui/source/styled/fragments/UserCardInDropdownItem";
import { useErrorReporterFiltered } from "core/hooks/useErrorReporterFiltered";
import { BuildingsData } from "core/queries/GetBuildingSupervisors";
import { UserData } from "core/queries/SearchForUsers";
import { useUpdateBuildingSupervisors } from "core/queries/UpdateBuildingSupervisors";

interface AddSupervisorGroupItemProps {
  building: BuildingsData;
  closePortal(): void;
  user: UserData;
}

export const AddSupervisorGroupItem = ({
  building,
  closePortal,
  user,
}: AddSupervisorGroupItemProps) => {
  const { cleaningSupervisors } = building;
  const { email, id: userId } = user;
  const avatarUrl = user.avatar?.url;
  const userName = user.name || undefined;
  const isSupervisor =
    cleaningSupervisors.filter(supervisor => supervisor.id === userId).length >
    0;

  const errorReporter = useErrorReporterFiltered();
  const [onUpdateBuildingSupervisors, { loading: isUpdating }] =
    useUpdateBuildingSupervisors({
      awaitRefetchQueries: true,
      refetchQueries: ["GetBuildingSupervisors"],
    });

  const onClick = () => {
    if (isUpdating) {
      return;
    }

    closePortal();

    onUpdateBuildingSupervisors({
      variables: {
        buildingId: building.id,
        addedSupervisors: [userId],
      },
    }).catch(error => {
      errorReporter.notify(error);
    });
  };

  const title = isSupervisor ? "Already added" : "Add Supervisor";

  return (
    <GenericDropdownItem
      disabled={isSupervisor}
      title={title}
      onClick={onClick}
    >
      <UserCardInDropdownItem
        email={email}
        imageUrl={avatarUrl}
        name={userName}
      />
    </GenericDropdownItem>
  );
};
